import { createContext } from 'react';

export type EntityPickerTabBarContext = {
  value: string | number;
  onChange: (value: string | number) => void;
};

export const EntityPickerTabBarContext =
  createContext<EntityPickerTabBarContext | null>(null);
